import React, { useCallback, useEffect, useState } from 'react';
import { CircleClipPath } from '@visx/clip-path';
import { Group } from '@visx/group';
import { Circle } from '@visx/shape';
import { Text } from '@visx/text';
const BarGroupChartImage = (item) => {
  const [errorLoadingImage, setErrorLoadingImage] = useState(false);

  useEffect(() => {
    setErrorLoadingImage(false);
  }, [item.pic]);

  const onErrorLoadingImage = useCallback(() => {
    setErrorLoadingImage(true);
  }, []);

  const radius = Math.max(item.width, item.height) / 2;

  if (!item.pic || errorLoadingImage) {
    return (
      <svg overflow='visible'>
        <Group>
          <Circle
            key={`point-${item.parentId}-${item.x}-${item.y}`}
            id={`point-${item.parentId}-${item.x}-${item.y}`}
            cx={item.x}
            cy={item.y}
            r={radius}
            fill='#5b53df'
          />
          <Text
            x={item.x}
            y={item.y}
            fontSize='11px'
            fontWeight='bold'
            textAnchor='middle'
            verticalAnchor='middle'
            fill='#ffffff'
          >
            {item.initials.toUpperCase()}
          </Text>
        </Group>
      </svg>
    );
  }

  return (
    <svg overflow='visible'>
      <image
        href={item.pic}
        height={item.width}
        width={item.height}
        x={item.x - radius}
        y={item.y - radius}
        clipPath={`url(#icon-${item.parentId}-${item.x}-${item.y})`}
        onError={() => {
          onErrorLoadingImage();
        }}
      />
      <CircleClipPath
        id={`icon-${item.parentId}-${item.x}-${item.y}`}
        key={`icon-${item.parentId}-${item.x}-${item.y}`}
        className='dot'
        cx={item.x}
        cy={item.y}
        r={radius}
      />
    </svg>
  );
};

export default BarGroupChartImage;
